import React from 'react';
import Icon from '../../../components/AppIcon';

const VideoTutorials = ({ videos, onVideoClick }) => {
  const formatDuration = (duration) => {
    return duration;
  };

  const formatViews = (views) => {
    if (views >= 1000000) {
      return Math.floor(views / 1000000) + 'M';
    } else if (views >= 1000) {
      return Math.floor(views / 1000) + 'K';
    }
    return views?.toString();
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl text-text-primary mb-4">
            Video Tutorials
          </h2>
          <p className="text-lg text-text-secondary">
            Visual guides with cultural context for South Asian weddings
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos?.map((video) => (
            <div
              key={video?.id}
              onClick={() => onVideoClick?.(video?.id)}
              className="bg-white rounded-xl shadow-soft hover:shadow-medium transition-all duration-200 cursor-pointer overflow-hidden group"
            >
              <div className="relative">
                <img
                  src={video?.thumbnail}
                  alt={video?.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                
                {/* Play Button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center group-hover:bg-white transition-colors">
                    <Icon name="Play" size={24} className="text-text-primary ml-1" />
                  </div>
                </div>
                
                {/* Duration */}
                <div className="absolute bottom-4 right-4 bg-black/70 text-white px-2 py-1 rounded text-sm">
                  {formatDuration(video?.duration)}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="font-heading font-semibold text-lg text-text-primary mb-2 group-hover:text-primary transition-colors">
                  {video?.title}
                </h3>
                
                <p className="text-text-secondary text-sm mb-4">
                  {video?.description}
                </p>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-1 text-text-muted text-sm">
                    <Icon name="Eye" size={14} />
                    <span>{formatViews(video?.views)} views</span>
                  </div>
                  
                  <div className="flex items-center space-x-1 text-primary text-sm">
                    <Icon name="Play" size={14} />
                    <span>Watch Now</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <div className="bg-surface-100 rounded-xl p-8">
            <Icon name="Video" size={48} className="text-text-muted mx-auto mb-4" />
            <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
              More Tutorials Coming Soon
            </h3>
            <p className="text-text-secondary">
              We're creating more video content to help you navigate the platform and plan your perfect wedding.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoTutorials;